import { Loader } from "./Loader";
import { Source } from "./Source";

export class Input {

    public semantic: string;
    public offset: number;
    public source: Source | any;

    public loadBlob (dataView: DataView, loader: Loader) {

        let offset = 0;
        let semanticResult = loader.util.readString(dataView, offset);
        this.semantic = semanticResult.string;
        offset = semanticResult.offset;

        this.offset = dataView.getInt32(offset, true);
        offset += 4;

        let sourceIdentity = dataView.getInt32(offset, true);
        offset += 4;

        this.source = loader.getBlob(sourceIdentity);
    }

    public sample<T>(offset: number): T {

        if (this.source instanceof Source) {

            if (this.source.type === 'float') {

                let result = new Float32Array(this.source.stride);
                for (let i = 0; i < this.source.stride; i++) {
                    result[i] = this.source.floats[offset * this.source.stride + i];
                }

                return result as any as T;
            } else if (this.source.type === 'string') {
                // TODO: Return array of strings or just the string directly? Are there ever string sources with stride > 1 ?
                let result = [];
                for (let i = 0; i < this.source.stride; i++) {
                    // result.push(self.source.strings[offset * self.source.stride + i]);
                    result.push(offset * this.source.stride + i); // instead of strings, return indices
                }
                return result as any as T;
            }
        } else {
            // vertices node, could in theory hold multiple inputs but assume its only ever 1
            return this.source.inputs[0].sample(offset) as T; // TODO: How to handle offsets in this case?
        }
    }

    public getValue<T>(index: number): T {
        var result = [];
        for (var i = 0; i < this.source.stride; i++) {
            if (this.source.type === 'float') {
                result.push(this.source.floats[index + i]);
            } else if (this.source.type === 'string') {
                result.push(this.source.strings[index + i]);
            }
        }
        return result as any as T;
    }
}
